import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Lock, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && user !== false) {
      navigate('/admin', { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const result = await login(email, password);
    setSubmitting(false);
    if (result.ok) {
      toast.success('Επιτυχής σύνδεση');
      navigate('/admin', { replace: true });
    } else {
      toast.error(result.error || 'Αποτυχία σύνδεσης');
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-slate-800 border border-slate-700 p-8">
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-4">
              <Lock className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-white tracking-wider">ADMIN PANEL</h1>
            <p className="text-slate-400 text-sm mt-2">PrimeTech Santorini</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-slate-300 text-sm mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="w-full bg-slate-700 border border-slate-600 text-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="admin@primetech-santorini.gr"
              />
            </div>
            <div>
              <label className="block text-slate-300 text-sm mb-2">Κωδικός</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="w-full bg-slate-700 border border-slate-600 text-white px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-500"
                placeholder="••••••••"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full bg-orange-500 text-white py-3 font-bold tracking-wider hover:bg-orange-600 transition-colors disabled:opacity-50 flex items-center justify-center"
            >
              {submitting ? <Loader2 className="w-5 h-5 animate-spin" /> : 'ΣΥΝΔΕΣΗ'}
            </button>
          </form>
        </div>
        <p className="text-center text-slate-500 text-xs mt-6">
          Πρόσβαση μόνο για εξουσιοδοτημένο προσωπικό
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
